// 服务平台高级弹窗配置
export const siteConfig = {
    name: '服务平台',
    value: 'siteName',
    type: 'advance',
    unfold: true,
    advanceConfig: [
        { prop: 'escoCompanyNameCn', value: '服务平台名称' },
        { prop: 'escoCompanyNo', value: '服务平台编码' }
    ],
    tableConfig: [
        { prop: 'escoCompanyNo', value: '服务平台编码' },
        { prop: 'escoCompanyNameCn', value: '服务平台名称' }
    ],
    advanceUrl: '/searchPlatform',
    cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
};

// 供应商高级弹窗配置
export const carrierConfig = {
    name: '供应商',
    value: 'handlingCarrierName',
    type: 'advance',
    advanceNotSearch: true,
    queryConditionRequired: true,
    unfold: true,
    advanceConfig: [
        { prop: 'supplierNameCn', value: '供应商名称' },
        { prop: 'supplierCode', value: '供应商编码' }
    ],
    tableConfig: [
        { prop: 'supplierNameCn', value: '供应商名称' },
        { prop: 'supplierCode', value: '供应商编码' }
    ],
    method: 'post',
    prefix: '/api-tms',
    advanceUrl: '/srm/supplier/search',
    cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode']
};
